import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ElQuarterPicker',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'yyyy年第Q季度'
    },
    valueFormat: {
      type: String,
      default: 'yyyy-qq'
    },
    value: {
      type: String,
      default: ''
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: function value(val) {
      // console.log('change-------', val)
      this.changeValue(val);
    },
    readonly: function readonly(val) {
      this.canEdit = !val && this.editable;
      this.canPopover = !this.disabled && !val;
    },
    editable: function editable(val) {
      this.canEdit = !this.readonly && val;
    },
    disabled: function disabled(val) {
      this.canPopover = !val && !this.readonly;
    }
  },
  data: function data() {
    return {
      visible: false,
      showClear: false,
      // 控制清空按钮展示
      canEdit: true,
      // 是否可编辑
      canPopover: true,
      // 选择器弹出是否可用
      text: '',
      // 文本框值
      viewType: 1,
      // 视图类型，1季度，2年度
      viewYear: 0,
      // 当前年份
      viewList: [],
      // 数据列表
      lineCount: 0,
      // 数据行数
      title: '',
      // 选择器标题
      data: [0, 0] // 当前选择年度-季度
    };
  },
  mounted: function mounted() {
    var _this = this;
    // console.log('mounted--------', this.value)
    this.changeValue(this.value);

    // 设置文本框是否可编辑
    this.canEdit = !this.readonly && this.editable;
    this.canPopover = !this.disabled && !this.readonly;

    // 监听按键(上下左右键可以切换季度)
    document.onkeydown = function (event) {
      if (_this.visible) {
        var data = [_this.data[0], _this.data[1]];
        if (data[0] < 1 || data[1] < 1) {
          // 以当前季度为标准
          var curDate = new Date();
          data[0] = curDate.getFullYear();
          data[1] = parseInt(curDate.getMonth() / 3) + 1;
        }
        if (event.code === 'ArrowLeft') {
          // 上一个季度
          if (data[1] === 1) {
            data[0] = data[0] - 1;
            data[1] = 4;
          } else {
            data[1] = data[1] - 1;
          }
        } else if (event.code === 'ArrowRight') {
          // 下一个季度
          if (data[1] === 4) {
            data[0] = data[0] + 1;
            data[1] = 1;
          } else {
            data[1] = data[1] + 1;
          }
        } else if (event.code === 'ArrowUp') {
          // 上一年季度
          data[0] = data[0] - 1;
        } else if (event.code === 'ArrowDown') {
          // 下一年季度
          data[0] = data[0] + 1;
        } else {
          return;
        }

        // 超过年限的不处理
        if (data[0] < 1000 || data[0] > 9999) {
          return;
        }
        _this.data = data;
        _this.viewType = 1;
        _this.viewYear = data[0];
        _this.$emit('change', _this.formatTo(data, _this.valueFormat));
      }
    };
  },
  destroyed: function destroyed() {
    document.onkeydown = null;
  },
  methods: {
    // 季度文本变更
    changeText: function changeText() {
      if (this.checkFormat(this.format, this.text)) {
        // 设置值
        this.formatFrom(this.text, this.format);
        this.$emit('change', this.formatTo(this.data, this.valueFormat));
      } else {
        // 输入了无效的格式，还原回原来的值
        if (this.data[0] < 1 || this.data[1] < 1) {
          this.text = '';
        } else {
          this.text = this.formatTo(this.data, this.format);
        }
      }
      this.visible = false;
    },
    // 鼠标进入
    mouseEnter: function mouseEnter() {
      if (!this.disabled && !this.readonly && this.clearable && this.text !== '') {
        this.showClear = true;
      }
    },
    // 鼠标离开
    mouseLeave: function mouseLeave() {
      if (!this.disabled && this.clearable) {
        this.showClear = false;
      }
    },
    // 清除季度
    clear: function clear() {
      this.showClear = false;
      this.visible = false;
      this.$emit('change', '');
    },
    // 季度值变更
    changeValue: function changeValue(val) {
      this.viewType = 1;
      if (val) {
        // 反向格式化
        this.formatFrom(val, this.valueFormat);
        this.text = this.formatTo(this.data, this.format);
        this.viewYear = this.data[0];
      } else {
        this.text = '';
        this.data = [0, 0];
        this.viewYear = new Date().getFullYear();
      }
      this.initView();
    },
    // 初始化视图数据
    initView: function initView() {
      var list = [];
      var curDate = new Date();
      var curYear = curDate.getFullYear();
      var curQuarter = parseInt(curDate.getMonth() / 3) + 1;
      if (this.viewType === 1) {
        var index = 0;
        var _iterator = _createForOfIteratorHelper('一二三四'),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            index++;
            var item = {
              label: '第' + i + '季度',
              year: this.viewYear,
              quarter: index,
              current: false,
              active: false
            };
            if (this.viewYear === curYear && index === curQuarter) {
              item.current = true;
            }
            if (this.viewYear === this.data[0] && index === this.data[1]) {
              item.active = true;
            }
            list.push(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.title = this.viewYear + ' 年';
      } else {
        var start = parseInt(this.viewYear / 10) * 10;
        this.viewYear = start;
        for (var _i2 = 0; _i2 < 10; _i2++) {
          var year = start + _i2;
          var _item = {
            label: year + '',
            year: year,
            current: false,
            active: false
          };
          if (year === curYear) {
            _item.current = true;
          }
          if (year === this.data[0]) {
            _item.active = true;
          }
          list.push(_item);
        }
        this.title = start + ' 年 - ' + (start + 9) + ' 年';
      }
      this.viewList = list;
      this.lineCount = parseInt(list.length / 4);
      if (list.length % 4 > 0) {
        this.lineCount++;
      }
    },
    // 校验季度格式是否正确
    checkFormat: function checkFormat(pattern, val) {
      // 格式转成正则表达式
      var text = '';
      var _iterator2 = _createForOfIteratorHelper(pattern),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var char = _step2.value;
          var dict = '\\^$.+?*[]{}!';
          if (dict.indexOf(char) === -1) {
            text += char;
          } else {
            text += '\\' + char;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      text = text.replace('yyyy', '[1-9]\\d{3}');
      text = text.replace('qq', '0[1-4]');
      text = text.replace('q', '[1-4]');
      text = text.replace('Q', '[一二三四]');
      text = '^' + text + '$';
      var patt = new RegExp(text);
      return patt.test(val);
    },
    // 格式化季度到指定格式
    formatTo: function formatTo(data, pattern) {
      var text = pattern.replace('yyyy', '' + data[0]);
      text = text.replace('qq', '0' + data[1]);
      text = text.replace('q', '' + data[1]);
      text = text.replace('Q', '一二三四'.substr(data[1] - 1, 1));
      return text;
    },
    // 以指定格式解析季度
    formatFrom: function formatFrom(str, pattern) {
      var year = this.findText(str, pattern, 'yyyy');
      var quarter = this.findText(str, pattern, ['qq', 'q', 'Q']);
      this.data = [year, quarter];
    },
    // 查找文本数值
    findText: function findText(str, pattern, find) {
      if (find instanceof Array) {
        var _iterator3 = _createForOfIteratorHelper(find),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var f = _step3.value;
            var _val = this.findText(str, pattern, f);
            if (_val !== -1) {
              return _val;
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        return -1;
      }
      var index = pattern.indexOf(find);
      if (index === -1) {
        return index;
      }
      var val = str.substr(index, find.length);
      if (find === 'Q') {
        return '一二三四'.indexOf(val) + 1;
      } else {
        return parseInt(val);
      }
    },
    // 年份点击
    clickYear: function clickYear() {
      if (this.viewType !== 1) {
        return;
      }
      // 切换年度选择器
      this.viewType = 2;
      this.initView();
    },
    // 季度选择
    clickItem: function clickItem(item) {
      // console.log('select--------', item)
      if (this.viewType === 1) {
        // 选择季度
        this.$emit('change', this.formatTo([item.year, item.quarter], this.valueFormat));
        this.visible = false;
      } else {
        // 选择年度
        this.viewType = 1;
        this.viewYear = item.year;
        this.initView();
      }
    },
    // 上一年
    clickLast: function clickLast() {
      if (this.viewYear > 1000) {
        if (this.viewType === 1) {
          this.viewYear--;
          this.initView();
        } else {
          this.viewYear = this.viewYear - 10;
          this.initView();
        }
      }
    },
    // 下一年
    clickNext: function clickNext() {
      if (this.viewYear < 9999) {
        if (this.viewType === 1) {
          this.viewYear++;
          this.initView();
        } else {
          this.viewYear = this.viewYear + 10;
          this.initView();
        }
      }
    }
  }
};